module.exports = __webpack_public_path__ + "img/certificate-2.717990ad.jpg";